import background from 'src/assets/background.svg';
import styled from 'styled-components';

export const Container = styled.div`
  width: 80% !important;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  padding: 5.25rem 0;

  background-image: url(${background});
  background-size: cover;

  border-radius: 32px;

  margin-bottom: 4rem;

  h1 {
    padding: 0 10rem;

    font-weight: 700;
    font-size: 4rem;
    line-height: 6rem;

    color: ${({ theme }) => theme.colors.white};

    margin-bottom: 2rem;
  }

  p {
    padding: 0 16rem;

    font-weight: 400;
    font-size: 1.5rem;
    line-height: 2.4rem;

    color: ${({ theme }) => theme.colors.white};

    margin-bottom: 3rem;
  }

  a {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};

    height: 2.813rem;
    border-radius: 5px;
    font-size: 0.875rem;
    font-weight: 600;
    padding: 0.75rem 1.5rem;
    transition: all 0.2s;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 1rem;
      height: 1rem;

      margin-right: 0.5rem;
    }

    &:hover {
      border: 1px solid ${({ theme }) => theme.colors.primaryDark};
      color: ${({ theme }) => theme.colors.primaryDark};
    }
  }

  @media (min-width: 1300px) {
    a {
      font-size: 1rem !important;

      svg {
        width: 1.25rem;
        height: 1.25rem;
      }
    }
  }

  @media (min-width: 1900px) {
    width: 65% !important;
  }

  @media (max-width: 1400px) {
    padding: 4.5rem 0;

    h1 {
      font-size: 3rem;
      line-height: 5rem;
    }

    p {
      font-size: 1.25rem;
      line-height: 2.15rem;
    }
  }

  @media (max-width: 1100px) {
    h1 {
      padding: 0 5rem;

      font-size: 2.5rem;
      line-height: 3rem;
    }

    p {
      padding: 0 5rem;

      font-size: 1rem;
      line-height: 1.75rem;
    }
  }

  @media (max-width: 500px) {
    padding: 3rem 0;

    h1 {
      padding: 0 2rem;

      font-size: 2.25rem;
      line-height: 3rem;
    }

    p {
      padding: 0 2rem;
    }
  }
`;
